import { apiDelete, apiGet, apiPatch, apiPost } from "../../../utils";

export const createTariffTemplateAPI = (params, data) => {
    return apiPost(`/api/tariffTemplate/${params?.userId}/${params?.organizationId}`, data);
};

export const addTariffPdfDownloadAPI = (data) => {
    return apiPost('/api/tariffTemplate/add-downloadpdf', data);
};

export const getTariffPdfDataAPI = (params) => {
    return apiGet(`/api/tariffTemplate/get-tariff-pdfdata/${params}`);
};

export const getTariffTemplateAPI = (params) => {
    return apiGet(`/api/tariffTemplate/${params?.portIdentifier}`);
};

export const updateTariffTemplateAPI = (params, data) => {
    return apiPatch(`/api/tariffTemplate/${params?.templateId}`, data);
};

export const deleteTariffTemplateAPI = (params) => {
    return apiDelete(`/api/tariffTemplate/${params?.templateId}`);
};

export const liveShareTariffTemplateAPI = (params, data) => {
    return apiPatch(`/api/tariffTemplate/live-share-tariff/${params?.templateId}`, data);
};